module.exports = __webpack_public_path__ + "static/media/6p.253f8552.png";